<template>
  <div class="apd-overlay" @click.self="$emit('close')">
    <div class="card apd-card" role="dialog" aria-label="Detalhe da consulta">
      <div class="card-head">
        <h3>Detalhe da consulta</h3>
        <button class="apd-x" aria-label="Fechar" @click="$emit('close')">
          ✕
        </button>
      </div>

      <div class="apd-status">
        <span class="badge" :class="`badge--${statusVariant}`">
          {{ statusLabel }}
        </span>
        <span class="apd-when">{{ appt.dateLabel }} · {{ appt.time }}</span>
      </div>

      <div class="dl apd-dl">
        <div>
          <dt>Paciente</dt>
          <dd>{{ appt.patient }}</dd>
        </div>
        <div>
          <dt>Profissional de saúde</dt>
          <dd>{{ appt.doctor }}</dd>
        </div>
        <div>
          <dt>Telefone</dt>
          <dd>{{ formatPhone(detail.patientPhone) || "—" }}</dd>
        </div>
        <div>
          <dt>E-mail</dt>
          <dd class="apd-break">{{ detail.patientEmail || "—" }}</dd>
        </div>
      </div>

      <div class="field">
        <span class="label">Observação</span>
        <p class="apd-obs">
          {{ loading ? "Carregando…" : detail.observation || "—" }}
        </p>
      </div>

      <div class="apd-actions">
        <router-link
          v-if="detail.patientId"
          :to="{
            name: 'ClinicPatientProfile',
            params: { id: detail.patientId }
          }"
          class="btn btn--outline btn--sm"
        >
          Ver ficha do paciente
        </router-link>
        <button class="btn btn--primary btn--sm" @click="$emit('close')">
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Modal de detalhe de uma consulta clicada na grade da agenda. Os dados
// básicos (paciente/médico/horário/status) vêm da própria grade; contato e
// observação vêm de GET /admin/appointments/:id.
import { ClinicAgenda } from "@/services/clinica";
import { formatPhone } from "@/utils/formatPhone";

const STATUS_LABELS = {
  confirmada: { label: "Confirmada", variant: "success" },
  agendada: { label: "A confirmar", variant: "warning" },
  aguardando_pgto: { label: "Aguardando pgto", variant: "warning" },
  realizada: { label: "Realizada", variant: "neutral" },
  cancelada: { label: "Cancelada", variant: "danger" }
};

export default {
  name: "ClinicAppointmentDetail",
  props: {
    // { id, patient, doctor, time, dateLabel, status(pt) }
    appt: { type: Object, required: true }
  },
  data() {
    return {
      loading: true,
      detail: {
        patientId: null,
        observation: "",
        patientEmail: "",
        patientPhone: ""
      }
    };
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    formatPhone,
    async fetchDetail() {
      this.loading = true;
      try {
        const { data } = await ClinicAgenda.appointment(this.appt.id);
        this.detail = data;
      } catch (e) {
        this.$toast.error("Não foi possível carregar o detalhe da consulta");
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    statusLabel() {
      return (STATUS_LABELS[this.appt.status] || {}).label || this.appt.status;
    },
    statusVariant() {
      return (STATUS_LABELS[this.appt.status] || {}).variant || "neutral";
    }
  }
};
</script>

<style lang="scss" scoped>
.apd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-5);
}
.apd-card {
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
.apd-x {
  border: none;
  background: none;
  color: var(--color-gray-400);
  font-size: var(--font-size-md);
  cursor: pointer;
  &:hover {
    color: var(--color-gray-700);
  }
}
.apd-status {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.apd-when {
  font-size: var(--font-size-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-gray-700);
}
.apd-dl {
  gap: var(--space-3) var(--space-4);
}
.apd-break {
  overflow-wrap: anywhere;
}
.apd-obs {
  font-size: var(--font-size-sm);
  color: var(--color-gray-600);
  background: var(--color-gray-50);
  border-radius: var(--radius-md);
  padding: var(--space-3) var(--space-4);
  margin: 0;
  min-height: 42px;
}
.apd-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
}
</style>
